import { FileDown, FileText } from "lucide-react";
import { toast } from "sonner";
import { api, download } from "../lib/api";
import { useLoad } from "../lib/util";
import { Badge, Btn, Card, SectionTitle } from "../components/kit";
import { useSchool } from "./ctx";

export default function Templates() {
  const { month, setSection } = useSchool();
  const [d] = useLoad(async () => (await api.get("/s/form-templates", { params: { month } })).data, [month]);
  const list = d?.forms;
  const missing = d?.missing || [];
  const get = (f, ext = "pdf") => {
    if (["oficio", "capa"].includes(f) && missing.length && !window.confirm(`Faltam no cadastro: ${missing.join(", ")}.\nEsses campos sairão em branco. Gerar mesmo assim?`)) return;
    download(`/s/export/${f}?month=${month}&fmt=${ext}`, `${f}_${month}.${ext}`).catch((e) => toast.error(e.message, { duration: 9000 }));
  };
  return (
    <div className="space-y-5">
      <SectionTitle title="Formulários oficiais do mês" subtitle="Os modelos são os mesmos para todas as escolas. Os campos são preenchidos com o cadastro da escola e os dados do mês, nesta ordem." />
      {missing.length > 0 && (
        <div className="rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm" data-testid="templates-missing-alert">
          <div className="font-semibold text-amber-800">Complete o cadastro antes de gerar o ofício</div>
          <div className="text-amber-900 mt-1">Faltam: <b data-testid="templates-missing-list">{missing.join(", ")}</b>.</div>
          <div className="flex flex-wrap gap-3 mt-2 text-xs">
            <button className="underline" data-testid="templates-missing-settings" onClick={() => setSection("settings")}>Preencher UA, DRA e diretor em Relatórios e configurações (cadastro da escola e "Ofício e capa do mapa")</button>
          </div>
        </div>
      )}
      <Card>
        <ol className="space-y-3">
          {(list || []).map((t, i) => (
            <li key={t.form} className="flex flex-wrap items-center justify-between gap-3 border rounded-lg p-4" data-testid={`template-row-${t.form}`}>
              <div className="flex items-center gap-3">
                <span className="w-7 h-7 rounded-full bg-[#0B192C] text-white text-xs font-bold grid place-items-center">{i + 1}</span>
                <span className="font-semibold text-sm text-[#0B192C]">{t.label}</span>
                {!t.template && <Badge tone="amber">modelo ainda não disponível</Badge>}
              </div>
              {t.template && (
                <div className="flex flex-wrap gap-2">
                  <Btn variant="navy" data-testid={`template-preview-${t.form}`} onClick={() => get(t.form)}><FileDown className="w-4 h-4" />Baixar PDF</Btn>
                  <Btn variant="outline" data-testid={`template-word-${t.form}`} onClick={() => get(t.form, "docx")}><FileText className="w-4 h-4" />Baixar Word</Btn>
                </div>
              )}
            </li>
          ))}
        </ol>
        <p className="text-xs text-slate-500 mt-4">
          Dados da escola (nome, UA, DRA, município, endereço, telefone, diretor e matrícula) vêm do cadastro em{" "}
          <button className="underline text-[#0B192C]" data-testid="templates-open-settings" onClick={() => setSection("settings")}>Relatórios e configurações</button>; número do ofício, horários e matrículas por modalidade vêm de "Ofício e capa do mapa".
        </p>
      </Card>
    </div>
  );
}
